import graphql__43d799e8c77cfe8ad68f from "./__generated__/ContributionsCountBadge_contributions.graphql.js";import { defineMessages } from "react-intl";
import { graphql } from "react-relay";
import classNames from "classnames";

import { useResourcesList } from "../../ResourcesList/resourcesList";
import { useFormatMessage } from "../../Intl/Context";
import { isResourcesListFiltered } from "../../Utils/resourcesList";

const ContributionsCountBadge = props => {
  const resourcesList = useResourcesList();
  const { count: totalCount } = resourcesList.items;
  const isFiltered = isResourcesListFiltered(resourcesList);

  const t = useFormatMessage();
  const contributionsBadgeLabel = t(intlMessages.contributionsTotalCount, {
    count: totalCount
  });
  const contributionsTotalCountStatus =
    isFiltered &&
    t(intlMessages.contributionsTotalCountStatus, {
      count: totalCount
    });

  const className = classNames(
    "badge badge-pill bg-primary padding-xs white-space-none",
    props.className
  );

  return (
    <>
      <span className={className}>{contributionsBadgeLabel}</span>

      <span className="sr-only" role="status">
        {contributionsTotalCountStatus}
      </span>
    </>
  );
};

graphql__43d799e8c77cfe8ad68f;

export default ContributionsCountBadge;

const intlMessages = defineMessages({
  contributionsTotalCount: {
    id: "participativeModule.filters.badge.contributionsTotalCount",
    defaultMessage: `{count, plural,
        =0 {0 contribution}
        one {{count} contribution}
        other {{count} contributions}
      }`
  },
  contributionsTotalCountStatus: {
    id: "participativeModule.filters.badge.contributionsTotalCountStatus",
    defaultMessage: `{count, plural,
        =0 {Aucune contribution ne correspond à vos critères de recherche}
        one {{count} contribution correspond à vos critères de recherche}
        other {{count} contributions correspondent à vos critères de recherche}
      }`
  }
});
